import {gql} from '@apollo/client';

/**
 * GraphQL query to fetch tenant-level MCP server configurations.
 * Used by MCPToolMappingProvider to build a mapping from API ID to server name.
 */
export const MCP_TOOL_MAPPING_QUERY = gql`
  query MCPToolMappingQuery @skipAudit @engComponent(name: LLM) {
    mcpServerConfigs {
      id
      name
    }
  }
`;
